import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import ChangePassword from './settings/ChangePassword';
import PlaybackPreferences from './settings/PlaybackPreferences';

/// What one person chose for themselves. Deliberately its own page rather than a tab under the
/// server's settings: those belong to whoever runs the server, and most people who use one
/// cannot see them at all - but everybody has preferences of their own.
export default function PreferencesPage() {
  const { t } = useTranslation();

  return (
    <Stack spacing={3}>
      <Typography variant="h2">{t('preferences.title')}</Typography>

      <PlaybackPreferences />

      <ChangePassword />
    </Stack>
  );
}
